import { useState } from "react";
import { X } from "lucide-react";
import tubingWomanImage from "@/assets/gallery-tubing-woman.webp";
import kidsCabanasImage from "@/assets/gallery-kids-cabanas.webp";

import groupTubingImage from "@/assets/gallery-group-tubing.webp";
import relaxingTubesImage from "@/assets/gallery-relaxing-tubes.webp";
import familyPortraitImage from "@/assets/gallery-family-portrait.webp";
import momsKidsTubesImage from "@/assets/gallery-moms-kids-tubes.webp";

import riversideHangoutImage from "@/assets/gallery-riverside-hangout.webp";
import tubingPicnicImage from "@/assets/gallery-tubing-picnic.webp";
import friendsTubesImage from "@/assets/gallery-friends-tubes.webp";
import guyRiversideImage from "@/assets/gallery-guy-riverside.webp";
import womanTubingHatImage from "@/assets/gallery-woman-tubing-hat.webp";
import familyKayakImage from "@/assets/gallery-family-kayak.webp";
import friendsGroupTubesImage from "@/assets/gallery-friends-group-tubes.webp";
import familySwimmingImage from "@/assets/gallery-family-swimming.webp";
import bbqGrillingImage from "@/assets/gallery-bbq-grilling.webp";
import momChildRiverImage from "@/assets/gallery-mom-child-river.webp";
import boyFishingImage from "@/assets/gallery-boy-fishing.webp";
import picnicTableRiverImage from "@/assets/gallery-picnic-table-river.webp";
import kidsPlayingRiverImage from "@/assets/gallery-kids-playing-river.webp";
import kidsTikiHutsImage from "@/assets/gallery-kids-tiki-huts.webp";
import girlTubingImage from "@/assets/gallery-girl-tubing.webp";
import familyPicnicImage from "@/assets/gallery-family-picnic.webp";
import familyTubesFunImage from "@/assets/gallery-family-tubes-fun.webp";
import girlfriendsTubingImage from "@/assets/gallery-girlfriends-tubing.webp";

import donutFloatImage from "@/assets/gallery-donut-float.webp";

const PhotoGallerySection = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const photos = [
    { src: kidsCabanasImage, alt: "Kids swimming near riverside cabanas" },
    { src: tubingWomanImage, alt: "Woman relaxing while tubing on the river" },
    
    { src: groupTubingImage, alt: "Group tubing with Son's Blue River Camp tubes" },
    { src: relaxingTubesImage, alt: "Friends relaxing on tubes in the river" },
    { src: familyPortraitImage, alt: "Family enjoying time at Son's Blue River Camp" },
    { src: momsKidsTubesImage, alt: "Moms and kids ready to tube" },
    
    { src: riversideHangoutImage, alt: "Guests relaxing by the river with chairs" },
    { src: tubingPicnicImage, alt: "Group tubing near riverside picnic table" },
    { src: friendsTubesImage, alt: "Friends floating together on tubes" },
    { src: guyRiversideImage, alt: "Guest enjoying the riverside" },
    { src: womanTubingHatImage, alt: "Woman tubing with straw hat" },
    { src: familyKayakImage, alt: "Family kayaking on the river" },
    { src: friendsGroupTubesImage, alt: "Group of friends tubing together" },
    { src: familySwimmingImage, alt: "Family swimming with life vests" },
    { src: bbqGrillingImage, alt: "Guest grilling BBQ at the ranch" },
    { src: momChildRiverImage, alt: "Mom and child playing in the river" },
    { src: boyFishingImage, alt: "Boy fishing in the river" },
    { src: picnicTableRiverImage, alt: "Picnic table setup by the river" },
    { src: kidsPlayingRiverImage, alt: "Kids playing in the river with tubes" },
    { src: kidsTikiHutsImage, alt: "Kids swimming near tiki huts" },
    { src: girlTubingImage, alt: "Girl smiling while tubing" },
    { src: familyPicnicImage, alt: "Family enjoying riverside picnic" },
    { src: familyTubesFunImage, alt: "Family having fun tubing together" },
    { src: girlfriendsTubingImage, alt: "Girlfriends group tubing selfie" },
    
    { src: donutFloatImage, alt: "Fun donut float on the river" },
  ];

  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-brown mb-4">
            A Day at <span className="text-river">Son's Blue River Camp</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Float, swim, grill, relax — then do it all again tomorrow.
          </p>
        </div>

        {/* Photo Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-w-6xl mx-auto">
          {photos.map((photo, index) => (
            <button
              key={index}
              onClick={() => setSelectedImage(photo.src)}
              className={`relative overflow-hidden rounded-2xl group cursor-pointer ${
                index === 0 ? "col-span-2 row-span-2" : ""
              }`}
            >
              <img
                src={photo.src}
                alt={photo.alt}
                className="w-full h-full object-cover aspect-square group-hover:scale-110 transition-transform duration-500"
                loading="lazy"
                decoding="async"
                width={300}
                height={300}
              />
              <div className="absolute inset-0 bg-brown/0 group-hover:bg-brown/20 transition-colors duration-300" />
            </button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-brown/90 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-6 right-6 w-12 h-12 rounded-full bg-cream/10 hover:bg-cream/20 flex items-center justify-center text-cream transition-colors"
            onClick={() => setSelectedImage(null)}
            aria-label="Close lightbox"
          >
            <X className="h-6 w-6" />
          </button>
          <img
            src={selectedImage}
            alt="Gallery image"
            className="max-w-full max-h-[90vh] rounded-2xl shadow-elevated"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default PhotoGallerySection;
